var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.176215 1.4047C0.13415 1.51521 0.111115 1.6351 0.111115 1.76038V11.6122C0.111115 11.6735 0.116627 11.7335 0.127184 11.7917L3.6713 7.36161C3.8438 7.14598 4.15845 7.11102 4.37408 7.28352C4.58971 7.45603 4.62467 7.77067 4.45217 7.9863L0.792808 12.5605C0.892793 12.5941 0.999831 12.6122 1.11111 12.6122H16.8889C17.0002 12.6122 17.1072 12.5941 17.2072 12.5605L13.5478 7.9863C13.3753 7.77067 13.4103 7.45603 13.6259 7.28352C13.8416 7.11102 14.1562 7.14598 14.3287 7.36161L17.8728 11.7918C17.8834 11.7335 17.8889 11.6735 17.8889 11.6122V1.76038C17.8889 1.6351 17.8659 1.51521 17.8238 1.4047L9.83205 6.73253C9.32821 7.06843 8.6718 7.06843 8.16795 6.73253L0.176215 1.4047ZM16.9812 0.764579C16.9508 0.761798 16.92 0.760376 16.8889 0.760376H1.11112C1.07999 0.760376 1.0492 0.761798 1.01881 0.76458L8.72265 5.90048C8.8906 6.01244 9.10941 6.01244 9.27736 5.90048L16.9812 0.764579Z",
    fill: "#FAFAFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.d31b232ce280523dfccd6d3381e15688.svg";
export { ForwardRef as ReactComponent };